"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var moment_1 = __importDefault(require("moment"));
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../javelin-exports");
var date_time_all_1 = require("./date-time-all");
/********************************************* EXPORT *********************************************/
/**
 * Date methods Javelin requires all clients to implement
 * @author Andrew Faulkner & Julien Guerinet
 * @since 2.5.0
 */
var JavelinDate = /** @class */ (function () {
    function JavelinDate() {
    }
    /**
     * @return [JZonedDateTime] instance representing right now
     */
    JavelinDate.zonedNow = function () { return new date_time_all_1.ZonedDateTime(moment_1.default()); };
    /**
     * @return [JLocalDate] instance representing today
     */
    JavelinDate.localNow = function () { return new date_time_all_1.LocalDate(moment_1.default()); };
    /**
     * @param year  Date year
     * @param month Date month
     * @param day   Date day
     * @return [JLocalDate] instance for the given parameters
     */
    JavelinDate.localOf = function (year, month, day) {
        var date = new date_time_all_1.LocalDate(moment_1.default(year + "-" + month + "-" + day, 'YYYY-MM-DD'));
        if (date.isValid())
            return date;
        throw new Error("Invalid date given: year: " + year + "; month: " + month + "; day: " + day);
    };
    return JavelinDate;
}());
exports.JavelinDate = JavelinDate;
/**************************************** METADATA BINDING ****************************************/
/**
 * Bind metadata from JLocalDate "interface" spit out by the transpiler
 */
Reflect.defineProperty(JavelinDate, '$metadata$', {
    configurable: false,
    enumerable: false,
    writable: false,
    value: javelin_exports_1.javelin.DateInterface.$metadata$,
});
//# sourceMappingURL=javelin-date.js.map